<template>
  <div class="glossary">
    <div class="glossary__col">
      <div v-for="(item, index) in data[0]" :key="index" class="glossary__item">
        <span class="glossary__label" v-html="item[0]"></span>
        <span class="glossary__content" v-html="item[1]" />
      </div>
    </div>

    <div class="glossary__col">
      <div v-for="(item, index) in data[1]" :key="index" class="glossary__item">
        <span class="glossary__label" v-html="item[0]"></span>
        <span class="glossary__content" v-html="item[1]" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Glossary',

  props: {
    data: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.glossary {
  @include flexbox(flex-start, space-between);
  padding: 0 #{rem(55)} 0 0;

  &__col {
    width: 49%;
    @include flexbox(flex-start, space-between);
    flex-direction: column;
    max-height: 100%;
  }

  &__label,
  &__content {
    display: block;
    font-size: rem(16);
    color: #646464;
  }

  &__label {
    font-weight: $font-bold;
    min-width: rem(100);
  }

  &__item {
    @include flexbox(flex-start, flex-start);

    &:not(:last-child) {
      margin-bottom: rem(5);
    }
  }

  @include iPadProStyles {
    &__label,
    &__content {
      font-size: rem(20);
    }
  }
}
</style>
